import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import { routes } from './routes';

const App = () => {
  return (
    <Routes>
      {routes.map(({ path, component: Component, isPublic, adminOnly }) => {
        let element = <Component />;
        if (adminOnly) {
          element = <AdminRoute>{element}</AdminRoute>;
        }
        return (
          <Route
            key={path}
            path={path}
            element={isPublic ? element : <ProtectedRoute>{element}</ProtectedRoute>}
          />
        );
      })}
    </Routes>
  );
};

export default App;
